module.exports = __webpack_public_path__ + "static/media/2.570b2748.svg";